import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import useFirstRender from './useFirstRender';

const useChangeCurrency = (value: Function): void => {
  const currency = useSelector(select.currency.get);
  const firstRender = useFirstRender();

  useEffect(() => {
    if (!firstRender) value();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currency]);
};

export default useChangeCurrency;
